import cn from "classnames";
import { dateTimeToView } from "helpers/date";
import React, { useState } from "react";
import { deleteParcel, updateParcelStatus } from "sources/parcel";
import ParcelStatusesHistory from "./history";
import PlanDate from "./planDate";

export default function BidParcelItem({ bid, parcel, modal, getItem, relationType }) {
    const [loading, setLoading] = useState(false);

    const updateParcelStatusHandler = () => {
        setLoading(true);
        updateParcelStatus({ id: parcel.id }).then(() => getItem());
    };

    const showHistory = () => {
        modal({
            title: "История статуса",
            name: "infoModal",
            windowMod: "sm",
            body: (
                <div className="modal__body">
                    <ParcelStatusesHistory id={parcel.id} />
                </div>
            ),
        });
    };

    const deleteParcelHandler = () => {
        setLoading(true);
        modal({
            title: "Удалить информацию об отслеживании?",
            name: "confirm",
            action: () => deleteParcel({ id: parcel.id, entityId: bid.id, relationType }).then(() => getItem()),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    return (
        <div className={cn("parcel__card", { loading })}>
            <div className="mb-2">
                <h6>{parcel.externalId}</h6>
                <div className="d-flex justify-content-between mt-1">
                    <div className="link" onClick={showHistory}>
                        История статуса
                    </div>
                    <div className="link ml-2" onClick={updateParcelStatusHandler}>
                        Обновить статус
                    </div>
                </div>
            </div>
            {parcel.status && (
                <div className="card card-body p-2 mb-1">
                    <div className="d-flex">
                        <div className="pr-2">
                            <i
                                className={cn("parcel__checkbox", {
                                    "parcel__checkbox--finished": parcel.status.isFinal,
                                    "parcel__checkbox--unsuccess": !parcel.status.isSuccess,
                                })}
                            />
                        </div>
                        <div>
                            <div>{parcel.status.name}</div>
                            <div className="text-muted">{dateTimeToView(parcel.status.fixedAt)}</div>
                        </div>
                    </div>
                </div>
            )}
            <PlanDate plannedDeliveryDate={parcel.plannedDeliveryDate} id={parcel.id} getItem={getItem} />
            <div className="d-flex justify-content-between mt-2">
                {parcel.url ? (
                    <a
                        href={parcel.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-xs btn-outline-primary"
                    >
                        Подробная информация
                    </a>
                ) : (
                    <div />
                )}
                <div className="btn btn-xs btn-outline-danger" onClick={deleteParcelHandler}>
                    Удалить
                </div>
            </div>
        </div>
    );
}
